import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useContext } from 'react';
import { NavHashLink as NavLink } from 'react-router-hash-link';
import Typed from 'react-typed';
import { ThemeContext } from '../../contexts/ThemeContext';
import { headerData } from '../../data/headerData';
import { socialsData } from '../../data/socialsData';
import './Landing.css';

import { FaFacebook, FaTwitter } from 'react-icons/fa';
import github from '../../assets/svg/social/github.svg';
import leetcode from '../../assets/svg/social/leetcode.svg';
import linkedin from '../../assets/svg/social/linkedin.svg';
function Landing() {
  const { theme, drawerOpen } = useContext(ThemeContext);

  const useStyles = makeStyles((t) => ({
    resumeBtn: {
      color: theme.primary,
      borderRadius: '30px',
      textTransform: 'inherit',
      textDecoration: 'none',
      width: '150px',
      fontSize: '1rem',
      fontWeight: '500',
      height: '50px',
      fontFamily: 'var(--primaryFont)',
      border: `3px solid ${theme.primary}`,
      transition: '100ms ease-out',
      '&:hover': {
        backgroundColor: theme.buttonColor,
        color: theme.secondary,
        border: `3px solid ${theme.buttonColor}`,
      },
      [t.breakpoints.down('sm')]: {
        width: '180px',
      },
    },
    contactBtn: {
      backgroundColor: theme.primary,
      color: theme.secondary,
      borderRadius: '30px',
      textTransform: 'inherit',
      textDecoration: 'none',
      width: '150px',
      height: '50px',
      fontSize: '1rem',
      fontWeight: '500',
      fontFamily: 'var(--primaryFont)',
      border: `3px solid ${theme.primary}`,
      transition: '100ms ease-out',
      '&:hover': {
        backgroundColor: theme.buttonColor,
        color: theme.secondary,
        border: `3px solid ${theme.buttonColor}`,
      },
      [t.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
  }));

  const classes = useStyles();

  return (
    <div className='landing' style={{ backgroundColor: theme.quaternary }}>
      <div className='landing--container'>
        <div
          className='landing--container-left'
        >
          <div className='lcl--content'>
            {socialsData.leetcode && (
              <a href={socialsData.leetcode} target='_blank' rel='noreferrer'>
                <img src={leetcode} alt='d' className='leetcodeicon' />
              </a>
            )}
            {socialsData.linkedIn && (
              <a href={socialsData.linkedIn} target='_blank' rel='noreferrer'>
                <img src={linkedin} alt='d' className='leetcodeicon' />
              </a>
            )}
            {socialsData.github && (
              <a href={socialsData.github} target='_blank' rel='noreferrer'>
                <img src={github} alt='d' className='leetcodeicon' />
              </a>
            )}
            {socialsData.twitter && (
              <a href={socialsData.twitter} target='_blank' rel='noreferrer'>
                <FaTwitter
                  className='landing--social twitter-icon'
                  style={{ color: theme.primary }}
                  aria-label='Twitter'
                />
              </a>
            )}
            {socialsData.facebook && (
              <a href={socialsData.facebook} target='_blank' rel='noreferrer'>
                <FaFacebook
                  className='landing--social facebook-icon'
                  style={{ color: theme.primary }}
                  aria-label='facebook'
                />
              </a>
            )}
          </div>
        </div>
        <img
          src={headerData.image}
          alt=''
          className='landing--img'
          style={{
            opacity: `${drawerOpen ? '0' : '1'}`,
            borderColor: theme.primary,
          }}
        />
        <div
          className='landing--container-right'

        >
          <div className='lcr--content' style={{ color: theme.tertiary }}>
            <h6>{headerData.title}</h6>
            <h1>{headerData.name}</h1>
            <Typed
              strings={[
                'Full-stack Developer',
                'Frontend Developer',
                'Backend Developer',
              ]}
              typeSpeed={40}
              backSpeed={50}
              className='typed-header'
              style={{ color: theme.primary, fontSize: '20px' }}
              loop
            />
            <p>{headerData.desciption}</p>

            <div className='lcr-buttonContainer'>
              {headerData.resumePdf && (
                <a
                  href={headerData.resumePdf}
                  download='resume'
                  target='_blank'
                  rel='noreferrer'
                >
                  <Button className={classes.resumeBtn}>Download CV</Button>
                </a>
              )}
              {headerData.notes && (
                <a href={headerData.notes} target='_blank' rel='noreferrer'>
                  <Button className={classes.resumeBtn}>Learning</Button>
                </a>
              )}
              <NavLink to='/#contacts' smooth={true} spy='true' duration={2000}>
                <Button className={classes.contactBtn}>Contact</Button>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Landing;
